import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import type { ResponseBody } from '../react-query.config';
import { isGameEnabled } from '@/lib/platform-filters';

type GetDailyRevealsResponse = ResponseBody<'/api/admin/daily-reveals', 'get'>;
export type DailyReveal = GetDailyRevealsResponse['daily_reveals'][number];

interface GetDailyRevealsParams {
  limit?: number;
  offset?: number;
  status?: string;
}

export const getDailyReveals = (params?: GetDailyRevealsParams): Promise<GetDailyRevealsResponse> =>
  api.get('/daily-reveals', { params });

export const dailyRevealQueryKeys = {
  all: ['daily-reveals'] as const,
  lists: () => [...dailyRevealQueryKeys.all, 'list'] as const,
  list: (filters?: any) => [...dailyRevealQueryKeys.lists(), filters] as const,
};

export const useGetDailyRevealsQuery = (params?: GetDailyRevealsParams) => {
  return useQuery({
    queryKey: dailyRevealQueryKeys.list(params),
    queryFn: () => getDailyReveals(params),
    select: data => data.daily_reveals || [],
    refetchInterval: 30_000,
    // A game this client didn't deploy has no admin routes registered, so asking is a
    // guaranteed 404 — and on a 30s interval it would be a recurring one.
    enabled: isGameEnabled('dailyReveal'),
  });
};
